import React from 'react';
import PropTypes from 'prop-types';
import { Elements } from '@stripe/react-stripe-js';

const clientIdentities = new WeakMap();
let nextClientIdentity = 0;

// Elements treats its Stripe instance as immutable. Changing the salon client
// must recreate the provider and its payment fields; ordinary rerenders keep
// the same identity so entered payment details survive within the same account.
export default function SalonStripeElements({ stripe, ...props }) {
  let identity = 'unavailable';
  if (stripe) {
    if (!clientIdentities.has(stripe)) clientIdentities.set(stripe, ++nextClientIdentity);
    identity = clientIdentities.get(stripe);
  }
  return <Elements key={identity} stripe={stripe} {...props} />;
}

SalonStripeElements.propTypes = {
  stripe: PropTypes.object,
};
